import { defineStore } from "pinia";
import type { About } from "~/modules/about/models/About.interface";
import AboutService from "~/modules/about/services/about.service";

export const useConfigStore = defineStore("configStore", () => {
  const state = reactive<About>({
    technicalVersion: null,
    marketingVersion: null,
    isMobileAppOfflineMode: false,
    isCartographyEnabled: false,
    platformType: undefined,
  });

  async function getConfig() {
    const response = await AboutService.getAbout();
    Object.assign(state, response);
  }

  return {
    ...toRefs(state),
    getConfig,
  };
});
